// import React, { useState, useEffect } from 'react'
import React from 'react'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import NormalLayoutContainer from '../shared/NormalLayoutContainer'
import PageTitle from '../../components/page-title'
import styles from './index.module.scss'
import { ROUTES } from '../../routes'

export default function OnlineSchedulePage () {
  return (
    <NormalLayoutContainer>
      <PageTitle>
        <div className={styles.header}>
          Online Schedule Settings
        </div>
      </PageTitle>
      <h2 className={styles.secondaryHeader}>Set Up Products (Step: 1/3)</h2>
      <div className='list-group-item'>
        <div className='flex justify-between flex-row'>
          <div className='mr-16'>
            <div className='font-bold text-3xl my-2'></div>
            <div className='text-2xl my-2'>
              Enter details for each Asset Type and select which to show as a product on your Online Schedule Site. <br />
              Roll-off dumpsters are the only product type currently supported, however additional options are in the works!
            </div>
          </div>

          <div className='h-12 flex self-center'>
            <Link
              to={ROUTES.onlineScheduleAssets}
              className='dis-btn dis-btn-lg dis-btn-primary'>
              <span className='font-medium text-2xl'>
                SET ASSETS
              </span>
            </Link>
          </div>
        </div>
      </div>
      <h2 className={styles.secondaryHeader}>Customize Company Information (Step: 2/3)</h2>
      <div className='list-group-item'>
        <div className='flex justify-between flex-row'>
          <div className='mr-16'>
            <div className='font-bold text-3xl my-2'></div>
            <div className='text-2xl my-2'>
              Customize your company information including terms and conditions for services.
            </div>
          </div>

          <div className='h-12 flex self-center'>
            <Link
              className='dis-btn dis-btn-lg dis-btn-primary'
              to={ROUTES.onlineScheduleDetails}>
              Customize Company Details
            </Link>
          </div>
        </div>
      </div>
      <h2 className={styles.secondaryHeader}>Finalize Process (Step: 3/3)</h2>
      <div className='list-group-item'>
        <div className='flex justify-between flex-row'>
          <div className='mr-16'>
            <div className='font-bold text-3xl my-2'></div>
            <div className='text-2xl my-2'>
              Review our Dispatcher Privacy Policy and activate your site.
            </div>
          </div>

          <div className='h-12 flex self-center'>
            <Link
              className='dis-btn dis-btn-lg dis-btn-primary'
              to ={ROUTES.onlineScheduleAgreements}>
              Finalize
            </Link>
          </div>
        </div>
      </div>
      <h2 className={styles.secondaryHeader}>Best Practices</h2>
      <div className='list-group-item'>
        <div className='flex justify-between flex-row'>
          <div className='mr-16'>
            <div className='font-bold text-3xl my-2'></div>
            <div className='text-2xl my-2'>
              Configure your online scheduling availability, including cutoff time, service days, and specific dates when scheduling is unavailable.
            </div>
          </div>
          <div className='h-12 flex self-center'>
            <Link to={ROUTES.onlineSchedulingCalender} className={cn('dis-btn dis-btn-lg dis-btn-primary')}>
              Calendar Settings
            </Link>
          </div>
        </div>
      </div>
      <div className='list-group-item'>
        <div className='flex justify-between flex-row'>
          <div className='mr-16'>
            <div className='font-bold text-3xl my-2'></div>
            <p className='text-2xl my-2'>
              With our SMS Communication feature, you can set up an On Creation SMS to notify your customer as soon as a service is confirmed.
              Simply select &quot;On Creation&quot; for the Online Schedule Ticket Type selected in Step 2. <br />
              Refer to our
              <a href='https://support.dispatcher.com/en/articles/12462082-customer-sms-communications' target='_blank' rel='noopener noreferrer'>
                &nbsp;Customer SMS Communications
              </a>
              &nbsp;article for more details.
            </p>
          </div>

          <div className='h-12 flex self-center'>
            <Link to={ROUTES.smsSettings} className={cn('dis-btn dis-btn-lg dis-btn-primary')}>
              SMS Settings
            </Link>
          </div>
        </div>
      </div>
    </NormalLayoutContainer>
  )
}
